import * as React from 'react';

// Components
import EntityOptions from '../../../../../../../../../../components/EntityOptions';
import TableCellRenderDropdown from '../TableCellRenderDropdown';

interface Props {
    entityTypeId?: ?number;
}

export class EntityTableCellRenderDropdown extends React.PureComponent<Props> {
    render() {
        const { entityTypeId } = this.props;

        return (
            <EntityOptions entityTypeId={entityTypeId} useCompositeKey>
                <TableCellRenderDropdown {...this.props} />
            </EntityOptions>
        );
    }
}

export default EntityTableCellRenderDropdown;
